import * as React from "react";
import ReactJWPlayer from "react-jw-player";
import { JWPLAYER_SCRIPT } from "../../constants";

// BASE COMPONENT DOCS: https://github.com/micnews/react-jw-player
// JWPLAYER DOCS: https://developer.jwplayer.com/jw-player/docs/javascript-api-reference/

function Player({ id, ...props }) {
  return (
    <ReactJWPlayer playerId={id} playerScript={JWPLAYER_SCRIPT} {...props} />
  );
}

export default Player;



// WEBPACK FOOTER //
// ./app/javascript/components/core/Player.tsx